import * as actionTypes from '../actions/actionTypes';
import moment from 'moment';

const initState = {
  loading: false,
  admins: null,
};

const updateAdmin = (admins, action) => {
  const newAdmins = [...admins];
  const { data, id } = action;
  let idx = newAdmins.findIndex(admin => admin.id === id);
  // deep clone admins
  const newAdmin = { ...newAdmins[idx] };
  // updating
  newAdmin.email = data.email;
  newAdmin.role = data.role;
  newAdmin.id = id;
  newAdmins[idx] = newAdmin;
  return newAdmins;
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_ADMIN_START:
      return { ...state, loading: true };
    case actionTypes.CREATE_ADMIN_END:
      return { ...state, loading: false };
    case actionTypes.FETCH_ADMINS_START:
      return { ...state, loading: true };
    case actionTypes.FETCH_ADMINS_END:
      const { admins } = action;
      return { ...state, loading: false, admins };
    case actionTypes.UPDATE_ADMIN_STATE:
      return {
        ...state,
        loading: true,
        admins: updateAdmin(state.admins, action),
      };
    case actionTypes.DELETE_ADMIN_START:
      return { ...state, loading: true };
    case actionTypes.DELETE_ADMIN_END:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const parseAdmins = admins => {
  if (!admins) return null;
  return admins
    .filter(e => e['id'] !== 1)
    .map(e => {
      if (typeof e['last_login_at'] === typeof 0) {
        const timeUnix = moment.unix(e['last_login_at']);
        e['last_login_at'] = timeUnix.format('h:mm A, DD-MM-YYYY');
      }
      if (typeof e['updated_at'] === typeof 0) {
        const timeUnix = moment.unix(e['updated_at']);
        e['updated_at'] = timeUnix.format('h:mm A, DD-MM-YYYY');
      }
      return e;
    });
};



// WEBPACK FOOTER //
// ./src/store/reducers/admins.js